










import { Component, Vue, Prop } from 'vue-property-decorator';
import { TweenMax, TimelineMax, Power2 } from 'gsap';

@Component
export default class BmnLoadingScreen extends Vue {
  private bmnLoader = new TimelineMax({repeat: -1});
  public mounted() {
    this.bmnLoader.to(this.$refs.bmnLoaderImg, 0.4, {y: -50, ease: Power2.easeOut});
    this.bmnLoader.to(this.$refs.bmnLoaderImg, 0.3, {y: 0, ease: Power2.easeIn});
    this.bmnLoader.to(this.$refs.bmnLoaderImg, 0.2, {scaleX: 1.1, ease: Power2.easeOut});
    this.bmnLoader.to(this.$refs.bmnLoaderImg, 0.2, {scaleX: 1, ease: Power2.easeIn});
  }
}
